import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { DocumentFileModule } from '@Work/Accounts/proprietary/controls/document-controls/document-file.module';
import { StateHelperService } from '@Core/services/proprietary/state-helper.service';
import { DocumentObjectService } from './document-object.service';
import { DocumentObjectState } from './document-object.state';
import { MultiDocumentObjectService } from './multidocument-object.service';
import { MultiDocumentObjectState } from './multidocument-object.state';

@NgModule({
    imports: [DocumentFileModule, NgxsModule.forFeature([DocumentObjectState, MultiDocumentObjectState])],
    providers: [DocumentObjectService, MultiDocumentObjectService, StateHelperService],
    exports: [DocumentFileModule]
})
export class DocumentObjectModule { }
